import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IComment, CommentMeta } from '../../../model/comment'
import commentStore from '../../comment/comment-store'

export default async function fetchComments(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.getComments(convo).then((comments: IComment[]) => {
    for(let i=0; i<comments.length; i++) {
      comments[i].meta = new CommentMeta()
    }
    // console.log('setting num likes for index: ' + i + ': ' + numLikes.value)
    convoStore.commitSetComments({ convo: convo, comments: comments })
    for(let i=0; i<comments.length; i++) {
      commentStore.dispatchSetMeta(comments[i])
    }
  })

  return
}
